/* Condition guide — condition-guide.js
   Opens the product page's Refind Condition Scale <dialog> from the (i)
   beside CONDITION. Markup: snippets/condition-scale.liquid (the opener) and
   snippets/condition-guide.liquid (the dialog, and why it is a native one).

   showModal() does the heavy lifting — inert page, Esc, focus return, top
   layer. This file adds only what the platform doesn't:
     - the close button;
     - closing on a click on the backdrop. Both the press AND the release must
       land outside the panel, so a text selection dragged out past the panel
       edge (which reports a click on the <dialog>) doesn't close it.

   The dialog is looked up when the (i) is clicked, not when the opener
   connects: the opener comes before the dialog in the markup. */

if (!customElements.get('condition-guide-opener')) {
  const isOutside = (dialog, event) => {
    const rect = dialog.getBoundingClientRect();
    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  };

  const wireDialog = (dialog) => {
    if (dialog.dataset.conditionGuideWired) return;
    dialog.dataset.conditionGuideWired = 'true';

    const close = dialog.querySelector('[data-condition-guide-close]');
    if (close) close.addEventListener('click', () => dialog.close());

    let pressedOutside = false;
    dialog.addEventListener('pointerdown', (event) => {
      pressedOutside = event.target === dialog && isOutside(dialog, event);
    });
    dialog.addEventListener('click', (event) => {
      if (pressedOutside && event.target === dialog && isOutside(dialog, event)) dialog.close();
      pressedOutside = false;
    });
  };

  class ConditionGuideOpener extends HTMLElement {
    connectedCallback() {
      if (this.wired) return;
      this.wired = true;

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', () => this.open());
    }

    open() {
      const dialog = document.getElementById(this.dataset.dialog);
      if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;

      wireDialog(dialog);
      dialog.showModal();
    }
  }

  customElements.define('condition-guide-opener', ConditionGuideOpener);
}
